module.exports = __webpack_public_path__ + "40ae9a0500562d4fa1148f38aa72ccde.png";